import { render, staticRenderFns } from "./LatestBillings.vue?vue&type=template&id=b4b34a26&scoped=true&"
import script from "./LatestBillings.vue?vue&type=script&lang=js&"
export * from "./LatestBillings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b34a26",
  null
  
)

export default component.exports